<template>
  <div class="PSS-slide view-slide">
    <img src="../../assets/images/PSS-bg.png">
    <div class="slide-text-part">
      <h3 v-on:click="select($event)">Provision Seed Selector</h3>
      <span class="minimized-indicator">
        <div class="tooltip">
          <label class="opened">Opened</label>
          <label class="closed">Closed</label>
        </div>
      </span>
      <div class="clearfix"></div>
      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
      <div class="text-center">
        <button>OPEN APP</button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  name: "SeedSelectorComponent"
};
</script>

